(function () {
    'use strict';
    /**
     * Really important in using this you must ensure the the HTML content provided has been through a server side sanitization
     */
    angular.module('app').filter('byPassSecurityTrustedHTMLSource', function ($sce) {
        return function (html) {
            return $sce.trustAsHtml(html);
        };
    });
}());